import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { FrameService } from 'src/app/core/services/frame.service';
import { PresetService } from 'src/app/core/services/preset.service';
import { IPreset } from 'src/app/core/models/preset.model';
import {
  NgbModalRef,
  NgbModalOptions,
  NgbModal,
  ModalDismissReasons,
} from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-frame-setup',
  templateUrl: './frame-setup.component.html',
  styleUrls: ['./frame-setup.component.css'],
})
export class FrameSetupComponent implements OnInit {
  @Input() userPresets: any;
  @Input() selectedFrameSetup: any;
  @Input() frames: any;
  @Input() userId: string;
  @Input() selectedSetting: any;
  @Input() currentUser: any;
  @Input() staticImage: boolean;

  @Output() frameSetup = new EventEmitter<Object>();

  @Output() loadPreset = new EventEmitter<Object>();
  @Output() initializePresets = new EventEmitter<Object>();

  fileToUpload: any;
  previewImage = null;

  frameSetupModal;
  uploadStaticImageModal;
  selectedTarget;
  toggleSelectFrame: boolean = false;
  toggleSelectFile: boolean = false;
  target: any = null;
  isAddingFrame = false;
  isAddingStaticFile = false;

  private dialogOptions: NgbModalOptions = {
    backdropClass: 'dark-backdrop',
    centered: true,
    windowClass: 'window-modal',
  };

  constructor(
    private frameService: FrameService,
    private presetService: PresetService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    console.log(this.userPresets)
  }

  loadUserPresets(settingsProfileId?: string): Observable<IPreset[]> {
    return this.presetService.getPresetsOfUser(this.userId, settingsProfileId);
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  openFrameSetup(content, preset) {
    if (this.currentUser?.readOnlyPermissions) {
      return false;
    }

    this.selectedFrameSetup = preset;
    this.selectedFrameSetup.isSelectedAll = true;

    this.selectedFrameSetup.targets.sort((a, b) => {
      return a.position - b.position;
    });

    this.getPositions(this.selectedFrameSetup);

    this.selectedFrameSetup.targets.forEach((target) => {
      if (target.useFrame === false) {
        this.selectedFrameSetup.isSelectedAll = false;
      }

      const framePreview = this.frames.find(
        (frame) => frame.id === target.frameId
      );

      if (framePreview) {
        const file =
          framePreview?.frameFiles?.find((file) => file.key === 'preview')
            ?.fileInfo?.thumbnailPath || null;
        target.framePreview = file;
      }
    });

    this.frameSetupModal = this.modalService.open(content, this.dialogOptions);
    this.frameSetupModal.result.then(
      (result) => {},
      (reason) => {
        console.log(`Dismissed ${this.getDismissReason(reason)}`);
      }
    );
  }

  getPositions(preset) {
    let framePositions = [];
    let staticImagePositions = [];

    preset.targets.forEach((target) => {
      if (target.useFrame) {
        framePositions.push(target.position)
      }

      if (target.useStaticFile) {
        staticImagePositions.push(target.position)
      }
    });

    preset.framePositions = framePositions;
    preset.staticImagePositions = staticImagePositions;
  }

  assignFrame(frame) {
    if (this.selectedFrameSetup.frame) {
      this.frameService
        .deleteAssignedFrame(
          this.userId,
          this.selectedFrameSetup.frame.id,
          this.selectedFrameSetup.id,
          this.selectedSetting?.id
        )
        .subscribe((deletedFrame) => {
          console.log('frame removed.');
          if (frame !== null) {
            this.frameService
              .assignFrameToPreset(
                this.userId,
                frame.id,
                this.selectedFrameSetup.id,
                this.selectedSetting?.id
              )
              .subscribe((res) => {
                console.log('dodato'); 
                this.loadPreset.emit(res[0].presetId);
                this.loadUserPresets(this.selectedSetting?.id).subscribe(
                  (res) => {
                    this.initializePresets.emit(res);
                  }
                );
                this.toastr.success('Frame assigned');
              });
          } else {
            this.loadPreset.emit(this.selectedFrameSetup.id);
            this.loadUserPresets(this.selectedSetting?.id).subscribe((res) => {
              this.initializePresets.emit(res);
            });
          }
        });
    } else {
      // nije imao treuntni frame
      if (frame) {
        this.frameService
          .assignFrameToPreset(
            this.userId,
            frame.id,
            this.selectedFrameSetup.id,
            this.selectedSetting?.id
          )
          .subscribe((res) => {
            console.log('dodato');
            this.loadPreset.emit(res[0].presetId);
            this.loadUserPresets(this.selectedSetting?.id).subscribe((res) => {
              this.initializePresets.emit(res);
            });
            this.toastr.success('Frame assigned');
          });
      }
    }
  }

  onSelectTarget(target) {
    this.toggleSelectFrame = true;
    this.target = target;
  }

  selectAllFrame(preset) {
    let body: any;
    if (!this.selectedFrameSetup.isSelectedAll) {
      preset.targets.forEach((target) => {
        if (!target.useFrame) {
          body = {
            useFrame: true,
          };
          this.frameService
            .updateTarget(
              this.userId,
              this.selectedFrameSetup.id,
              target.id,
              body,
              this.selectedSetting?.id
            )
            .subscribe((res) => {
              target.useFrame = true;
            });
        }
        this.selectedFrameSetup.isSelectedAll = true;
      });
    } else {
      preset.targets.forEach((target) => {
        body = {
          useFrame: false,
        };
        this.frameService
          .updateTarget(
            this.userId,
            this.selectedFrameSetup.id,
            target.id,
            body,
            this.selectedSetting?.id
          )
          .subscribe((res) => {
            target.useFrame = false;
          });
      });
      this.selectedFrameSetup.isSelectedAll = false;
    }
    setTimeout(() => {
      this.loadUserPresets(this.selectedSetting?.id).subscribe((res) => {
        this.initializePresets.emit(res);
      });
    }, 1000);
  }

  addFrameOnTarget(frame) {
    if (this.isAddingFrame) return;

    let body = {
      useFrame: !!frame,
    };

    if (frame) {
      body['frameId'] = frame.id;
    }

    this.isAddingFrame = true;

    this.frameService
      .updateTarget(
        this.userId,
        this.selectedFrameSetup.id,
        this.target.id,
        body,
        this.selectedSetting?.id
      )
      .subscribe(
        (res) => {
          this.loadUserPresets(this.selectedSetting?.id).subscribe(
            (presets) => {
              this.initializePresets.emit(presets);
            }
          );

          const index = this.selectedFrameSetup.targets.findIndex(
            (target) => target.id === this.target.id
          );

          if (index !== -1) {
            const framePreview = this.frames.find((f) => f.id === frame?.id);
            const file =
              framePreview?.frameFiles?.find((file) => file.key === 'preview')
                ?.fileInfo?.thumbnailPath || null;

            this.selectedFrameSetup.targets[index] = {
              ...res,
              framePreview: framePreview ? file : null,
            };
          }

          this.getPositions(this.selectedFrameSetup)

          this.toggleSelectFrame = false;
          this.target = null;
          this.isAddingFrame = false;
        },
        (err) => {
          this.isAddingFrame = false;
        }
      );
  }

  handleChange(target) {
    if (target.useStaticFile) {

      if (target.staticFile) {
        this.useStaticFile(target)
      } else {
        this.selectedTarget = target;
        this.toggleSelectFile = true;
      }
    } else {
      this.useStaticFile(target);
    }
  }

  closeFileUpload() {
    this.toggleSelectFile = false;

    if (!this.selectedTarget.staticFile) {
      // ukolko vec postoji staticFile, onda se ne prebacuje na false useStaticFile
      const trgt = this.selectedFrameSetup.targets.find(target => target.id === this.selectedTarget.id);

      if (trgt) {
        trgt.useStaticFile = false;
      }
      
    }
    this.selectedTarget = null;
  }

  useStaticFile(trgt?: any) {
    let body = new FormData();
    const target = trgt || this.selectedTarget;
    body.append('useStaticFile', target.useStaticFile);

    if (this.fileToUpload) {
      body.append('staticFile', this.fileToUpload);
    }

    this.isAddingStaticFile = true;

    this.frameService
      .updateTarget(
        this.userId,
        this.selectedFrameSetup.id,
        target.id,
        body,
        this.selectedSetting?.id
      )
      .subscribe((res) => {
        this.selectedFrameSetup.isSelectedAll = false;
        this.isAddingStaticFile = false;

        const index = this.selectedFrameSetup.targets.findIndex(
          (trgt) => trgt.id === target.id
        );

        if (index !== -1) {
          this.selectedFrameSetup.targets[index] = {
            ...res,
          };
        }

        this.getPositions(this.selectedFrameSetup);

        this.loadUserPresets(this.selectedSetting?.id).subscribe((presets) => {
          this.initializePresets.emit(presets);
        });

        this.previewImage = null;
        this.fileToUpload = null;
        this.selectedTarget = null;
        this.toggleSelectFile = false;
      }, err => {
        this.isAddingStaticFile = false;
      });
  }

  openUploadImage(target) {
    this.selectedTarget = target;
    this.toggleSelectFile = true;
  }

  getFile(event) {
    this.fileToUpload = event.target.files[0];
    this.readURL(this.fileToUpload);
  }

  readURL(image) {
    const reader = new FileReader();
    reader.addEventListener(
      'load',
      () => {
        this.previewImage = reader.result;
      },
      false
    );
    if (image) {
      reader.readAsDataURL(image);
    }
  }
}
